import type { TableColumn } from '@/components/alerts/types'
import type { TickerResponse } from '@/services/tickers-v2-service/types'
import { getTradeUrl } from '@/utils'

export const getTickersColumns = (): TableColumn[] => {
  return [
    {
      field: 'symbol',
      width: '120px',
      header: 'table.asset',
      class: 'text-center',
      dynamic: true,
      inner: 'a',
      innerPropsGenerator: (v: object) => {
        const data = v as TickerResponse
        const asset = data.symbol.split('/')[0] as string
        const href = getTradeUrl(data.exchange, asset, true)
        return {
          target: '_blank',
          href: href,
          class: 'pit hover',
        }
      },
    },
    {
      field: 'exchange',
      width: '110px',
      header: 'table.exchange',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit success capitalize',
      },
    },
    {
      field: 'vol24h',
      width: '110px',
      header: 'table.vol24h',
      class: 'text-center',
      sortable: true,
      inner: 'span',
      innerProps: {
        class: 'pit success digit',
      },
    },
    {
      field: 'change',
      width: '100px',
      header: 'table.change',
      class: 'text-center',
      sortable: true,
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as TickerResponse
        const isPositive = Number(data.change) >= 0
        return {
          class: isPositive ? 'pit success digit' : 'pit danger digit',
        }
      },
    },
  ]
}
